import { useEffect } from "react";
import useGetIntervals from "./useIntervals";
import useBookingContextUrl from "./useBookingContextUrl";
import dayjs from "dayjs";

interface useContextHasIntervalsProps {
  externalScenario?: string;
  canFetch?: boolean;
}

const useContextHasIntervals = (props?: useContextHasIntervalsProps) => {
  const { externalScenario, canFetch = true } = props || {};
  const { scenario } = useBookingContextUrl();
  const [{ intervals }, getIntervals] = useGetIntervals({
    shouldSaveContext: false,
  });

  const isScenarioValid = intervals && intervals.length > 0;

  useEffect(() => {
    if (canFetch) {
      getIntervals(
        externalScenario ?? scenario,
        {
          fields: {
            dateRange: {
              end: {
                gte: dayjs().format("YYYY-MM-DD"),
              },
            },
          },
          pagination: {
            page: 1,
            size: 1,
          },
        },
        false,
      );
    }
  }, [scenario, externalScenario, canFetch]);

  return {
    isScenarioValid,
    intervals,
  };
};

export default useContextHasIntervals;
